/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import Radio from "@material-ui/core/Radio";
import React from "react";

const RadioButton = styled(({ ...props }) => <Radio {...props} />)`
  ${({ theme }) => `
  `}
`;

export default RadioButton;
